import React from 'react';
import { FormattedMessage } from "react-intl";
import './Eingabe.css';

class EingabeAnschlussprofil extends React.Component {
    constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

  handleChange(event) {
        // console.log('Anschlussprofil ' + event.target.value);
        if(this.props.checked === true){

            this.props.SelectedAnschlussprofil(event.target.value);
            //this.setState({selectedAnschlussprofil:event.target.value})
        }

  }
  handleCheckboxChange(event) {
      // console.log("Check Change " + event.target.checked);
      //this.setState({checked : event.target.checked })
      this.props.checkedAnschlussprofil(event.target.checked);
  }
  checkProfil(){
    let selected = this.getProfilWert(this.props.value);
    let calculated= this.getProfilWert(this.props.calculatedAnschlussprofil)

    if(selected > calculated){
        return "Gewähltes Anschlussprofil größer als berechnet";
    }
    else if(selected < calculated){
        return "Gewähltes Anschlussprofil kleiner als berechnet";
    }
  }
  getProfilWert(profil){
        switch(profil){
            case "SBM20":
                return 1;
            case "SBM30":
                return 2;
            case "SBM40":
                return 4;
            case "WER30":
                return 5;
            case "WER40":
                return 6;
            default:
                return undefined;
      }
  }

  render() {
    return (
        <>
          <label><FormattedMessage id='Anschlussprofil' /></label>
            <div className={"flex"}>


              <select value={this.props.value} onChange={this.handleChange} disabled={!this.props.checked}>
                  <option key={1} value='SBM20'>SBM20</option>
                  <option key={2} value='SBM30'>SBM30</option>
                  <option key={3} value='SBM40'>SBM40</option>
                  <option key={4} value='WER30'>WER30</option>
                  <option key={5} value='WER40'>WER40</option>

              </select>
              {/*  Voruebergehend deaktiviert*/}
              {/*<span><input type="checkbox" checked={this.props.checked}  onChange={this.handleCheckboxChange}/></span>*/}

              <p>{this.checkProfil()}</p>
            </div>
        </>
    );
  }
}
export default EingabeAnschlussprofil;
